import React from 'react';

import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import useNavigationLayoutPreference, {
  NAVIGATION_LAYOUTS,
  NavigationLayout,
} from '~/hooks/useNavigationLayoutPreference';

interface NavigationLayoutMenuItemProps {
  onClick?: () => void;
  targetLayout?: NavigationLayout;
}

export default function NavigationLayoutMenuItem({ onClick, targetLayout }: NavigationLayoutMenuItemProps) {
  const [navigationLayout, setNavigationLayout] = useNavigationLayoutPreference();
  const nextLayout =
    targetLayout ??
    (navigationLayout === NAVIGATION_LAYOUTS.HEADER ? NAVIGATION_LAYOUTS.SIDEBAR : NAVIGATION_LAYOUTS.HEADER);
  const isSwitchingToSidebar = nextLayout === NAVIGATION_LAYOUTS.SIDEBAR;

  const handleClick = () => {
    setNavigationLayout(nextLayout);
    onClick?.();
    window.location.reload();
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>{isSwitchingToSidebar ? <ViewSidebarIcon /> : <ViewWeekIcon />}</ListItemIcon>
      <ListItemText>{isSwitchingToSidebar ? 'Use sidebar navigation' : 'Use header navigation'}</ListItemText>
    </MenuItem>
  );
}
